import styled from 'styled-components'
import { black, textMuted, mutedGrey, grey } from '@/theme/colors'
import { fontSizes } from '@/theme/typography'
import { Button } from '@components/Button'
import { innerCardSurface, tintOnHover } from '@components/Card'

export const ViewerGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
	gap: 12px;
`

export const ViewerFileCard = styled.div`
	${innerCardSurface}
	${tintOnHover}
	padding: 0;
	overflow: hidden;
`

export const ViewerThumbnail = styled.div`
	width: 100%;
	aspect-ratio: 1;
	overflow: hidden;
	background: ${grey};
	display: flex;
	align-items: center;
	justify-content: center;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`

export const ViewerDocIcon = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 4px;
	color: ${mutedGrey};

	span {
		font-size: ${fontSizes.micro};
		font-weight: 700;
		text-transform: uppercase;
		color: ${textMuted};
	}
`

export const ViewerFileName = styled.div`
	padding: 6px 8px;
	font-size: ${fontSizes.micro};
	color: ${black};
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`


export const EditButton = styled(Button).attrs({ variant: 'secondary' as const, size: 'sm' as const })``

export const ViewerFooter = styled.div`
	display: flex;
	justify-content: flex-end;
	padding-top: 8px;
`
